import script from "./activity.vue?vue&type=script&setup=true&lang=js"
export * from "./activity.vue?vue&type=script&setup=true&lang=js"

import "./activity.vue?vue&type=style&index=0&id=01f1dc07&lang=scss"

const __exports__ = script;

export default __exports__